export default __webpack_public_path__ + "static/media/death_star_by_radiusss.d8115dab.png";